import * as React from 'react';
import { Grid, FormControl, Select, MenuItem, Button } from '@material-ui/core';
import WorldMapComponent from './WorldMapComponent';
import RegionCountryInfoComponent from '../../components/dashboard/RegionCountryInfoComponent'
import ActiveUsersComponent from 'src/components/dashboard/ActiveUsersComponent';
import ReportsComponent from 'src/components/dashboard/ReportsComponent';
import PendingUsersComponent from 'src/components/dashboard/PendingUsersComponent';
import ReminderConfigurationComponent from 'src/components/dashboard/ReminderConfigurationComponent';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';
import { UserType } from 'src/constants/Enum/UserType';

export default class AdminDashboardComponent extends React.Component<any, any> {

    state = {
        isAdmin: false,
        dashobardData: {},
        surveys: [],
        showReminder: false
    };

    constructor(props: any) {
        super(props);

        this.handleSurvyeYearChange = this.handleSurvyeYearChange.bind(this);
        this.handleReminderConfig = this.handleReminderConfig.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.saveReminderConfig = this.saveReminderConfig.bind(this);
        this.gotoResponses = this.gotoResponses.bind(this);
        this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
        this.downloadProgressReport = this.downloadProgressReport.bind(this);
        this.handleDownloadAllModule = this.handleDownloadAllModule.bind(this);
        this.handleDownloadAllModuleForecast = this.handleDownloadAllModuleForecast.bind(this);
    }

    componentDidMount() {
        this.setState({
            isAdmin: this.props.isAdmin
        });
    }

    handleSurvyeYearChange(event: any) {
        this.props.handleSurvyeYearChange(event.target.value);
    }

    handleReminderConfig = () => {
        this.setState({ showReminder: true });
    }

    onDialogClose = () => {
        this.setState({ showReminder: false })
    }

    saveReminderConfig = (data: any) => {
        this.setState({ showReminder: false })
        this.props.saveReminderConfig(data)
    }

    gotoResponses(isDashboard: any) {
        this.props.gotoResponses(isDashboard);
    }

    downloadProgressReport() {
        this.props.downloadProgressReport();
    }

    handleDownloadExcel = (selectedRegionId: any, selectedCountryId: any, selectedModuleId: any) => {
        this.props.handleDownloadExcel(selectedRegionId, selectedCountryId, selectedModuleId);
    }

    handleDownloadAllModule = (selectedRegionId: any, selectedCountryId: any, selectedModuleId: any) => {
        this.props.handleDownloadAllModule(selectedRegionId, selectedCountryId, selectedModuleId);
    }

    handleDownloadAllModuleForecast = (selectedRegionId: any, selectedCountryId: any, selectedModuleId: any) => {
        this.props.handleDownloadAllModuleForecast(selectedRegionId, selectedCountryId, selectedModuleId);
    }

    render() {
        const dashboardData: any = this.props.dashboardData;
        const survey: any = this.props.surveys ? this.props.surveys : [];
        const ActiveUsers: any = dashboardData && dashboardData.activeUsers;
        const PendingUsers: any = dashboardData && dashboardData.pendingUsers;
        const loggedInUser = getLocalStorageValue('user');

        return (
            <div>
                <div className="pageHeading">
                    <Grid container={true} spacing={8}>
                        <Grid item={true} xs={6}>
                            <div className="pageTitleSection">
                                {survey.length > 0 &&
                                    <FormControl margin="normal" fullWidth={true}>
                                        <div><b>Select Survey:</b>&nbsp;&nbsp;
                                 <Select
                                                className="SurveySelect"
                                                value={this.props && this.props.selectedSurveyId}
                                                displayEmpty={true}
                                                onChange={this.handleSurvyeYearChange}
                                                inputProps={{
                                                    name: "title",
                                                    id: "surveyId"
                                                }}
                                            >
                                                {
                                                    survey.length > 0 && survey.map((item: any, key: any) => {
                                                        return <MenuItem
                                                            value={item.id}
                                                            key={key}
                                                            data-my-value={item.year}
                                                        >{item.title}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </div>
                                    </FormControl >}
                            </div>
                        </Grid>
                        <Grid item={true} xs={1}>
                            &nbsp;
                                </Grid>
                        <Grid item={true} xs={5}>
                            {
                                loggedInUser.roleId === UserType.HQAdmin || loggedInUser.roleId === UserType.RegionalAdmin ?
                                    <div className="text-right">
                                        {survey.length > 0 && <Button type="button" className="btn-blue-primary" variant="outlined" size="medium" onClick={this.handleReminderConfig}>
                                            Survey Reminder Notification
                                        </Button>
                                        }
                                    </div>
                                    :
                                    ''
                            }
                        </Grid>
                    </Grid>
                </div>

                <div className="pageContent">
                    <div className="contentSection">
                        <div className="contentMapSection">
                            <Grid container={true} spacing={24}>
                                <>
                                    <WorldMapComponent
                                        isAdmin={loggedInUser.roleId}
                                        regionData={dashboardData && dashboardData.regionWiseModuleCompletionDto}
                                    />
                                    {
                                        dashboardData && dashboardData.regionWiseModuleCompletionDto && dashboardData.regionWiseModuleCompletionDto.length > 0
                                        && <RegionCountryInfoComponent
                                            isAdmin={this.props.isAdmin}
                                            regionData={dashboardData && dashboardData.regionWiseModuleCompletionDto}
                                            gotoResponses={this.gotoResponses}
                                            downloadProgressReport={this.downloadProgressReport}
                                            selectedSurveyId={this.props.selectedSurveyId}
                                        />
                                    }
                                </>
                                {
                                    this.state.showReminder && (
                                        <ReminderConfigurationComponent
                                            onDialogClose={this.onDialogClose}
                                            showDialog={this.state.showReminder}
                                            saveReminderConfig={this.saveReminderConfig}
                                            selectedSurveyId={this.props.selectedSurveyId}
                                            adminDashboard={this.props.adminDashboard}
                                            regionalDashboard={this.props.regionalDashboard}
                                            surveys={survey}
                                            handleSurvyeYearChange={this.props.handleSurvyeYearChange}
                                        />
                                    )
                                }
                            </Grid>
                        </div>
                        {
                            loggedInUser.roleId === UserType.HQAdmin || loggedInUser.roleId === UserType.RegionalAdmin ?
                                <div className="contentMapBottomSection">
                                    <Grid container={true} spacing={24}>
                                        <ActiveUsersComponent ActiveUsers={ActiveUsers} />
                                        <ReportsComponent
                                            countryRegions={this.props.countryRegions}
                                            models={this.props.models}
                                            handleDownloadExcel={this.handleDownloadExcel}
                                            handleDownloadAllModule={this.handleDownloadAllModule}
                                            selectedSurveyId={this.props.selectedSurveyId}
                                        />
                                        <PendingUsersComponent PendingUsers={PendingUsers} />
                                    </Grid>
                                </div>
                                : loggedInUser.roleId === UserType.DataManagerSupply || loggedInUser.roleId === UserType.DataManagerSupplyRegional || loggedInUser.roleId === UserType.DataCollector ?
                                    <div className="contentMapBottomSection">
                                        <Grid container={true} spacing={24}>
                                            <ReportsComponent
                                                countryRegions={this.props.countryRegions}
                                                models={this.props.models}
                                                handleDownloadExcel={this.handleDownloadExcel}
                                                handleDownloadAllModuleForecast={this.handleDownloadAllModuleForecast}
                                                handleDownloadAllModule={this.handleDownloadAllModule}
                                                selectedSurveyId={this.props.selectedSurveyId}
                                            />
                                        </Grid>
                                    </div>
                                    : ''
                        }
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/AdminDashboardComponent.tsx